import React, { useState } from "react";
import EditObjectModal from "../../../../../../components/generic/EditObjectModal";
import {
  backendPatchWithoutRefresh,
} from "../../../../../../helpers/callBackend";

/**
 *
 * @param {Boolean} modalVisible used to determine when to show modal
 * @param {Function} handleCancelModal makes modal invisible when called
 * @param {Object} editableObject object to be edited
 * @param {Array.<Objects>} connections list of all connections
 * @param {Function} setConnections sets the connections array
 * @returns an edit object modal for individual accounts details
 */
const ConnectionsDetailsEditModal = (props) => {
  const [fields, setFields] = useState({
    description: {
      display_name: "Account Name",
      value: props.editableObject.description,
    },
    beneficiary_name: {
      display_name: "Entity",
      value: props.editableObject.beneficiary_name,
    },
    account_type: {
      display_name: "Account Type",
      value: props.editableObject.account_type,
    },
  });

  const handleSubmit = async (event, label) => {
    event.stopPropagation();
    const resp = await backendPatchWithoutRefresh(
      "/api/external-connections/",
      {
        data: { field: label, value: fields[label].value.trim() },
        sourceAccountId: props.editableObject.id,
        source: props.editableObject.source,
      }
    );
    if (resp.status == 200) {
      let updatedObject = { ...resp.data.source_account };
      let updatedExternalConnections = props.connections.map((item) => {
        if (item.id === updatedObject.id) {
          item = updatedObject;
        }
        return item;
      });
      await props.setConnections(updatedExternalConnections);
    }
  };

  return (
    <EditObjectModal
      modalTitle="Edit Account Information"
      fields={fields}
      setFields={setFields}
      handleSubmit={handleSubmit}
      modalVisible={props.modalVisible}
      handleCancelModal={props.handleCancelModal}
    />
  );
};

export default ConnectionsDetailsEditModal;
